export { default } from './ProfileForm.vue'
